import getCalendarFoldersOperation from 'owa-service/lib/operation/getCalendarFoldersOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import GetCalendarFoldersResponse from 'owa-service/lib/contract/GetCalendarFoldersResponse';

let activePromise = null;

export default function getCalendarFoldersService(
    ignoreCacheIfPresent?: boolean
): Promise<GetCalendarFoldersResponse> {
    if (!activePromise || ignoreCacheIfPresent) {
        activePromise = getCalendarFoldersOperation({ Header: getJsonRequestHeader() });
    }
    return activePromise;
}
